import React from "react";
import { Nav } from "reactstrap";
import { TitleWembii } from "../TitleWembii";
import { NavItem2 } from "./NavItem2";
import { useIntl } from "react-intl";
import { useRouterCore } from "../../../cores/router";
import { useBreakpointBelowLg } from "../../../hooks/useBreakpointBelowLg";

const SidebarUserRoutes: React.FC<{ collapseSideBar: boolean }> = ({
  collapseSideBar,
}) => {
  const intl = useIntl();
  const { routes, goToMeCompany } = useRouterCore();
  const isMobileSidebar = useBreakpointBelowLg();
  const showSectionTitle = !collapseSideBar || isMobileSidebar;

  return (
    <>
      <hr className="horizontal-separator my-3" />
      {showSectionTitle && (
        <TitleWembii Tag="h6">
          {intl.formatMessage({ id: "app.sidebar.myPlan" })}
        </TitleWembii>
      )}
      <Nav vertical>
        <NavItem2
          onClick={goToMeCompany}
          label={intl.formatMessage({ id: "app.sidebar.company" })}
          iconName="building"
          activeUrl={routes.meCompany}
        />
      </Nav>
    </>
  );
};

export default SidebarUserRoutes;
